import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Avatar from "@mui/material/Avatar";
import { useBoardUsers } from "../../../../../reactQuery/users";
import "./ImportCardMuiSelect.scss";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { getAPIBaseUrl } from "../../../../../utils/constants";
import CustomMenuItem from "../../../../../components/Menu/CustomMenuItem";
import useBoardIdByKey from "../../../../../hooks/useBoardIdByKey";
import { getResponseData } from "../../../../../reactQuery/response";

export default function MuiSelectDropdown({ handleUserId }) {
  const [selectedUser, setSelectedUser] = React.useState(null);
  const isMobile = useResponsive("down", "md");
  const { id } = useBoardIdByKey();
  const getUrl = getAPIBaseUrl();
  const { data } = useBoardUsers(id);
  const boardUsers = getResponseData(data, []);

  const handleChange = (event) => {
    const user = event.target.value;

    setSelectedUser(event.target.value);
    handleUserId(user);
  };

  return (
    <Box className="box-container">
      <p className="select-assignee">Assignee <span style={{ color: 'red' }}>*</span> :</p>
      <FormControl className="form-control" size="small" required>
        <InputLabel id="demo-simple-select-label">Select Assignee</InputLabel>
        <Select
          value={selectedUser}
          label="Select Assignee"
          onChange={handleChange}
          inputProps={{ "aria-label": "Without label" }}
          className="selected-assignee"
          MenuProps={{
            PaperProps: {
              elevation: 0,
              className: "muitiselect-menu-paper",
            },
            transformOrigin: { horizontal: "Right", vertical: "top" },
            anchorOrigin: { horizontal: "Right", vertical: "bottom" },
          }}
        >
          {boardUsers.map((item,index) => (
            <CustomMenuItem
              value={item.user_id}
              className="mui-select-menu-item"
              key={`import-card-csv-${index}`}
            >
              <Avatar
                alt=""
                src={getUrl + item.user_image}
                className="mui-select-avatar"
              />
              <span>{item.username}</span>
            </CustomMenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
